export class SearchPagination {
    constructor(data, searchField) {
        this.originalData = data;
        this.searchField = searchField;
    }
    *searchAndFilter(searchText, filterState = [], pageSize = 10) {
        let batch = [];
        for (const item of this.originalData) {
            try {
                if (filterState.length > 0) {
                    let found = filterState.every((filter) => {
                        let valuePresent = filter.keys.reduce((acc, key) => acc === null || acc === void 0 ? void 0 : acc[key], item);
                        let indexOfValue = filter.values.indexOf(valuePresent === null || valuePresent === void 0 ? void 0 : valuePresent.toString());
                        return indexOfValue >= 0;
                    });
                    if (!found)
                        continue;
                }
                if (searchText) {
                    let searchTextrsent = item[this.searchField];
                    const lowerSearchText = searchText.toLowerCase();
                    if (!(searchTextrsent === null || searchTextrsent === void 0 ? void 0 : searchTextrsent.toString().toLowerCase().includes(lowerSearchText)))
                        continue;
                }
                batch.push(item);
            }
            catch (error) {
                console.log(error, "searcherror");
            }
            if (batch.length % pageSize === 0) {
                yield [...batch];
            }
        }
        yield [...batch]; // Yield remaining records
    }
    *noSearchFilterData(pageSize = 10) {
        let batch = [];
        for (const item of this.originalData) {
            batch.push(item);
            if (batch.length % pageSize === 0) {
                yield [...batch];
            }
        }
        yield [...batch];
    }
    async newSearchAndFilter(searchText, filterState = [], pageSize = 10) {
        this.searchGenerator = (!!searchText || filterState.length > 0) ?
            this.searchAndFilter(searchText, filterState, pageSize)
            : this.noSearchFilterData(pageSize);
        //first batch
        return this.getNextPage().then((res) => {
            return res;
        });
    }
    async getNextPage() {
        return new Promise((resolve) => {
            var _a;
            if (this.searchGenerator) {
                let nextBatch = this.searchGenerator.next();
                resolve({ data: (_a = nextBatch.value) !== null && _a !== void 0 ? _a : [], done: nextBatch.done });
            }
            else {
                resolve({ data: [], done: true });
            }
            ;
        });
    }
}
